import { useEffect } from 'react';
import { useAuth } from '@/context/AuthContext';
import { Loader2, ShieldX } from 'lucide-react';

interface AdminRouteProps {
  children: React.ReactNode;
  onAccessDenied: () => void;
}

export const AdminRoute: React.FC<AdminRouteProps> = ({ children, onAccessDenied }) => {
  const { user, isLoading, isAdmin, profileFlagsLoaded } = useAuth();

  // Wait for both: session-load AND profile-flags-load. Otherwise on a hard
  // reload of an admin URL, AdminRoute can race-trigger access-denied between
  // session-loaded and admin-flag-loaded.
  const stillResolving = isLoading || (!!user && !profileFlagsLoaded);

  useEffect(() => {
    if (stillResolving) return;
    if (!user || !isAdmin) {
      onAccessDenied();
    }
  }, [user, stillResolving, isAdmin, onAccessDenied]);

  if (stillResolving) {
    return (
      <div className="min-h-[50vh] flex items-center justify-center">
        <Loader2 className="w-8 h-8 text-primary animate-spin" />
      </div>
    );
  }

  if (!user || !isAdmin) {
    return (
      <div className="min-h-[50vh] flex flex-col items-center justify-center text-center">
        <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mb-4">
          <ShieldX className="w-10 h-10 text-red-600" />
        </div>
        <h2 className="text-2xl font-bold text-slate-900 mb-2">Zugriff verweigert</h2>
        <p className="text-slate-500 mb-6">Du hast keine Berechtigung für den Admin-Bereich.</p>
        <button onClick={onAccessDenied} className="btn-primary">
          Zurück zum Dashboard
        </button>
      </div>
    );
  }

  return <>{children}</>;
};
